export const SENTRY_IGNORED_ERRORS: (string | RegExp)[] = [
  // Network/fetch errors — transient. Stale-chunk failures are captured explicitly in
  // lazy-with-reload with a `staleChunk` tag, so the substring filter keeps the noise out.
  "Failed to fetch",
  "Load failed",
  // Cancelled requests
  "AbortError",
  "signal is aborted without reason",
  // CSRF session expiry — already handled by redirect to /auth
  "Received status code 419",
  // Clipboard permission — browser restriction, not a bug
  "Read permission denied",
  // React DOM conflicts with browser extensions
  "Failed to execute 'removeChild' on 'Node'",
  "Failed to execute 'insertBefore' on 'Node'",
  // Third-party script errors
  "Message could not be passed",
  // View authorization — user-facing validation, not bugs
  /The selected view is invalid/,
  /You can only update views that you have created/,
  // View Transition API race conditions — browser-level, not application bugs
  /Failed to execute '\w+' on 'ViewTransition'/,
  "View transition was skipped",
  // Chrome refuses the page-change animation while the tab is hidden; the page still changes
  "Transition was aborted because of invalid state",
];
